import api, { ApiResponse } from './api';

export type ServerType = 'xaccel' | 'ffstream' | 'ssp';

export interface XaccelServer {
  id: number;
  name: string;
  server_url: string;
  server_token: string | null;
  is_active: number;
  is_default: number;
  server_type: ServerType;
  created_at: string;
  updated_at: string;
}

export interface CreateXaccelRequest {
  name?: string;
  server_url: string;
  server_token: string;
  is_default?: boolean;
  server_type?: ServerType;
}

export interface UpdateXaccelRequest {
  name?: string;
  server_url?: string;
  server_token?: string;
  is_active?: boolean;
  server_type?: ServerType;
}

export interface TestXaccelResponse {
  working: boolean;
  streams?: number;
  error?: string;
}

export const xaccelService = {
  async list(): Promise<XaccelServer[]> {
    const response = await api.get<ApiResponse<XaccelServer[]>>('/xaccel');
    return response.data.data;
  },

  async get(id: number): Promise<XaccelServer> {
    const response = await api.get<ApiResponse<XaccelServer>>(`/xaccel/${id}`);
    return response.data.data;
  },

  async create(data: CreateXaccelRequest): Promise<XaccelServer> {
    const response = await api.post<ApiResponse<XaccelServer>>('/xaccel', data);
    return response.data.data;
  },

  async update(id: number, data: UpdateXaccelRequest): Promise<XaccelServer> {
    const response = await api.put<ApiResponse<XaccelServer>>(`/xaccel/${id}`, data);
    return response.data.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/xaccel/${id}`);
  },

  async test(id: number): Promise<TestXaccelResponse> {
    const response = await api.post<ApiResponse<TestXaccelResponse>>(`/xaccel/${id}/test`);
    return response.data.data;
  },

  async setDefault(id: number): Promise<void> {
    await api.post(`/xaccel/${id}/set-default`);
  },
};
